import { render, staticRenderFns } from "./AgentProfileListingsSold.vue?vue&type=template&id=5342b664&scoped=true&"
import script from "./AgentProfileListingsSold.vue?vue&type=script&lang=ts&"
export * from "./AgentProfileListingsSold.vue?vue&type=script&lang=ts&"
import style0 from "./AgentProfileListingsSold.vue?vue&type=style&index=0&id=5342b664&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5342b664",
  null
  
)

export default component.exports